// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__iiZHZ","dataBlock":"styles_dataBlock__ieLUV","noOption":"styles_noOption__KXGMs"};